export const getNextStepsVideo = () => {
    const url = 'b156705bacab4a36ae6b446bd29e8352';

    return `<p><a href="https://www.loom.com/share/${url}" target="_blank"> <img style="max-width: 300px;" src="https://cdn.loom.com/sessions/thumbnails/${url}-with-play.gif" /></a></p>`;
};
